import React from 'react';
import uploadIcon from '../assets/upload.png';

const ImageUpload = ({ onImageUpload }) => {
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Remove the "data:image/jpeg;base64," part from the string
        const base64String = reader.result.split(',')[1];
        onImageUpload(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="image-upload-container">
      <label htmlFor="image-upload" className="upload-button">
        <img src={uploadIcon} alt="Upload" className="upload-icon" />
        Upload Image
        <input
          id="image-upload"
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={{ display: 'none' }}
        />
      </label>
    </div>
  );
};

export default ImageUpload; 